<template>
    <b-button
        variant="warning"
        @click.stop="confirmarDescomprometerSelecionados()"
        :disabled="comprometimentosSelecionados.length == 0"
        v-if="$temAcessoView('CONT-REQ-05')"
    >
        <span
            ><i class="fa fa-times-circle-o mr-2"></i> Descomprometer
            selecionados</span
        >
    </b-button>
</template>

<script>
export default {
    components: {},

    props: {
        requisicao: {
            type: Object,
            default: () => ({})
        },

        comprometimentosSelecionados: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDescomprometerSelecionados() {
            const quantidade = this.comprometimentosSelecionados.length
            const mensagem = `Confirma a realização do descomprometimento de ${quantidade}
                              comprometimento(s) selecionado(s) no RM?`
            this.$swal({
                title: 'Descomprometimento',
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.descomprometerSelecionados()
                }
            })
        },

        descomprometerSelecionados() {
            this.$emit('descomprometerSelecionados')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
